import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Button
} from "shards-react";

import PageTitle from "../components/common/PageTitle";
import backendUrl from "./../utils/backendUrl";

const axios = require('axios');

// Table columns, in order. The key is the bucket name /stats/own returns.
const PERIODS = [
  { key: "today", title: "Dnes" },
  { key: "yesterday", title: "Včera" },
  { key: "month", title: "Za 30 dní" }
];

// 1 hráč, 2 hráči, 5 hráčů.
const players = (count) => {
  if (count === 1) {
    return "1 hráč";
  }

  return count >= 2 && count <= 4 ? `${count} hráči` : `${count} hráčů`;
};

const date = (value) => new Date(value).toLocaleDateString("cs-CZ");
const dateTime = (value) => new Date(value).toLocaleString("cs-CZ");

// Hits on the first line, unique visitors below - same cells for a game row
// and for the totals row.
const counts = (buckets) => PERIODS.map(period => (
  <td key={period.key} className="text-right">
    <span className="d-block">{buckets[period.key].hits}</span>
    <span className="text-muted small">{players(buckets[period.key].unique_ips)}</span>
  </td>
));

class AdminPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      stats: null,
      error: null,
      loading: true
    };

    this.mounted = false;
    this.load = this.load.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.load();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  load() {
    this.setState({ loading: true, error: null });

    // Pass the query string along, so /admin?token=... still works if the
    // backend ever starts asking for a stats token.
    axios.get(`${backendUrl("/stats/own")}${this.props.location.search}`).then(
      response => this.update({ stats: response.data, loading: false }),
      error => this.update({
        error: (error.response && error.response.data && error.response.data.error_message)
          || "Statistiky se nepodařilo načíst.",
        loading: false
      })
    );
  }

  update(state) {
    if (this.mounted) {
      this.setState(state);
    }
  }

  renderTable() {
    const { stats } = this.state;

    return (
      <table className="table mb-0">
        <thead className="bg-light">
          <tr>
            <th scope="col" className="border-0">Hra</th>
            {PERIODS.map(period => (
              <th key={period.key} scope="col" className="border-0 text-right">
                {period.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {stats.games.map(game => (
            <tr key={game.game_id}>
              <td>{game.name}</td>
              {counts(game)}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="bg-light font-weight-bold">
            <td>Celkem</td>
            {counts(stats.totals)}
          </tr>
        </tfoot>
      </table>
    );
  }

  render() {
    const { stats, error, loading } = this.state;

    return (
      <Container fluid className="main-content-container px-4">
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title="Statistiky" subtitle="Admin" className="text-sm-left" />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4">
              <CardHeader className="border-bottom d-flex justify-content-between align-items-center">
                <h6 className="m-0">Spuštění našich her</h6>
                <Button size="sm" theme="white" onClick={this.load} disabled={loading}>
                  {loading ? "Načítám..." : "Obnovit"}
                </Button>
              </CardHeader>
              <CardBody className="p-0 pb-3">
                {error && <div className="px-4 py-3 text-danger">{error}</div>}
                {!stats && !error && <div className="px-4 py-3 text-muted">Načítám statistiky...</div>}
                {stats && this.renderTable()}
              </CardBody>
              {stats && (
                <CardFooter className="border-top text-muted small">
                  Druhý řádek je počet unikátních IP adres. Dny se počítají v pásmu {stats.timezone},
                  „Za 30 dní“ je od {date(stats.month_start)}. Data k {dateTime(stats.generated_at)}.
                </CardFooter>
              )}
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default AdminPage;
